export default {
  methods: {
    $notifyError(err) {
      this.$store.commit('notification/ACTIVE_NOTIFICATION', {
        type: 'error',
        text: 'System Error : ' + err.status + ' ' + err.statusText
      })
    },
    $notifySuccess(text) {
      this.$store.commit('notification/ACTIVE_NOTIFICATION', {
        type: 'success',
        text: text
      })
    },
    $snackbar(text, color = 'primary') {
      this.$store.commit('snackbar/SET_SNACKBAR', {
        title: text,
        color: color
      })
    }
  }
}
